import React from 'react';
import DealerCars from '../../containers/Cars/DealerCars';

const DealerCarsPage = () => {
  return <DealerCars />;
};

export default DealerCarsPage;
